import {
    ExcelExportParams,
    ProcessHeaderForExportParams,
} from 'ag-grid-community';
import { AccessTypeT } from 'business/definitions';
import { ACTIONS_FIELD } from './colDefinitions';

const ACCESS_TYPE_VALUE: Record<AccessTypeT, number> = {
    no_access: 0,
    restricted: 1,
    full_access: 2,
};

export const accessTypeComparator = (
    accessTypeA: AccessTypeT | undefined,
    accessTypeB: AccessTypeT | undefined,
): number => {
    const valueA = accessTypeA ? ACCESS_TYPE_VALUE[accessTypeA] : 0;
    const valueB = accessTypeB ? ACCESS_TYPE_VALUE[accessTypeB] : 0;
    return Math.sign(valueA - valueB);
};

export const getDefaultExportParams = (t: TranslationT): ExcelExportParams => ({
    allColumns: true,
    autoConvertFormulas: true, // instead of dataType='Formula'
    processCellCallback: (params) => {
        if (params.column.getColDef().cellRenderer === 'accessTypeCellRenderer')
            return t(
                `adminSpace.permissionsPanel.${params.value ?? 'no_access'}`,
            );
        if (params.column.getColDef().cellRenderer === 'booleanCellRenderer')
            return t(`common.${params.value}`);
        if (params.column.getColDef().field === ACTIONS_FIELD) return undefined;
        return params.value;
    },
    processHeaderCallback: (params: ProcessHeaderForExportParams) => {
        if (params.column.getColDef().field === ACTIONS_FIELD) return '';
        return params.column.getColDef().headerName ?? '';
    },
});
